var _path, _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDf20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.29,30H.71c-.25,0-.48-.13-.61-.34-.13-.21-.14-.47-.03-.7L14.36.36c.24-.48,1.04-.48,1.28,0l14.29,28.6c.11.22.1.49-.03.7-.13.21-.36.34-.61.34Zm-27.42-1.43h26.26L15,2.28,1.87,28.57Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.71,
    y: 10.87,
    width: 2.58,
    height: 10.16,
    rx: 0.78,
    ry: 0.78
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 23.84,
    r: 1.29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDf20);
export default __webpack_public_path__ + "static/media/DF20.9131a5171ba310b6c0a1ef2125b0b7b3.svg";
export { ForwardRef as ReactComponent };